import { USAGE_ACTION } from '../constants/sample.constants';

/**
 * バックエンド `backend/src/utils/sampleUsageRecordSignature.util.ts` と
 * 署名ロジックを同期すること（編集フォームの変更検知に使用）。
 */
export type UsageRecordSignatureRow = {
  usageDate: string | Date;
  action: string;
  purpose?: string;
  quantity: number;
  remainingQuantity: number;
  recordedBy?: string;
};

function formatUsageDateLocal(value: Date): string {
  const y = value.getFullYear();
  const m = String(value.getMonth() + 1).padStart(2, '0');
  const d = String(value.getDate()).padStart(2, '0');
  const h = String(value.getHours()).padStart(2, '0');
  const min = String(value.getMinutes()).padStart(2, '0');
  return `${y}-${m}-${d}T${h}:${min}`;
}

function normalizeUsageDateForSignature(value: string | Date): string {
  if (value instanceof Date) {
    return formatUsageDateLocal(value);
  }
  const trimmed = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(trimmed)) {
    return trimmed.slice(0, 16);
  }
  const parsed = new Date(trimmed);
  if (!Number.isNaN(parsed.getTime())) {
    return formatUsageDateLocal(parsed);
  }
  return trimmed;
}

function normalizePurposeForSignature(action: string, purpose?: string): string | null {
  const normalizedAction = action.trim();
  const normalizedPurpose = (purpose ?? '').trim();
  if (
    normalizedAction === USAGE_ACTION.CREATED ||
    normalizedPurpose === USAGE_ACTION.CREATED
  ) {
    return null;
  }
  return normalizedPurpose || null;
}

function normalizeRecordedByForSignature(value?: string): string | null {
  const trimmed = (value ?? '').trim();
  return trimmed || null;
}

/** 使用履歴の内容比較用シグネチャ（バックエンド sample.service.ts と同趣旨） */
export function buildUsageRecordsSignature(records: UsageRecordSignatureRow[]): string {
  const signatures = records
    .map((record) => {
      const action = (record.action ?? '').trim();
      return JSON.stringify({
        usageDate: normalizeUsageDateForSignature(record.usageDate),
        action,
        purpose: normalizePurposeForSignature(action, record.purpose),
        quantity: Number(record.quantity ?? 0),
        remainingQuantity: Number(record.remainingQuantity ?? 0),
        recordedBy: normalizeRecordedByForSignature(record.recordedBy),
      });
    })
    .sort();
  return JSON.stringify(signatures);
}
